import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { formatApiError } from "@/context/AuthContext";
import { CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("checking");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("Missing token in link."); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch((e) => { setStatus("error"); setMsg(formatApiError(e)); });
  }, [token]);

  return (
    <div data-testid="verify-page" className="min-h-[80vh] flex items-center justify-center bg-slate-50 px-6 py-12">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-md p-10 text-center">
        {status === "checking" && <div className="text-slate-500 font-mono text-xs uppercase tracking-widest">Verifying…</div>}
        {status === "ok" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-blue-600 mx-auto" strokeWidth={1.5}/>
            <h1 className="mt-4 font-display text-2xl font-semibold text-slate-900">Email verified.</h1>
            <p className="mt-2 text-sm text-slate-600">Your account is fully activated.</p>
            <Link to="/dashboard" className="mt-6 inline-block text-blue-700 hover:text-blue-800 font-medium">Go to dashboard →</Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto" strokeWidth={1.5}/>
            <h1 className="mt-4 font-display text-2xl font-semibold text-slate-900">Verification failed.</h1>
            <p className="mt-2 text-sm text-slate-600">{msg}</p>
            <Link to="/dashboard" className="mt-6 inline-block text-blue-700 hover:text-blue-800 font-medium">Return to dashboard</Link>
          </>
        )}
      </div>
    </div>
  );
}
